export type SlimLoadItem = {
  contains?: Array<object>
}

export const hasMixedPallets = (items: SlimLoadItem[]) =>
  items?.some(i => i.contains?.length > 1)
